
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_62114_201)","fill":"#4A4A4A"}},[_c('path',{attrs:{"d":"M8 12.664a.875.875 0 100-1.75.875.875 0 000 1.75z"}}),_c('path',{attrs:{"d":"M14.25 8a6.25 6.25 0 10-12.5 0 6.25 6.25 0 0012.5 0zM9.581 6.542c0-.622-.613-1.292-1.584-1.292-.971 0-1.583.67-1.583 1.292v.291a.75.75 0 11-1.5 0v-.291c0-1.632 1.478-2.792 3.083-2.792 1.606 0 3.084 1.16 3.084 2.792 0 1.375-1.05 2.41-2.339 2.704a.75.75 0 01-1.495-.079v-.584a.75.75 0 01.75-.75c.971 0 1.584-.669 1.584-1.291zM15.75 8A7.75 7.75 0 11.25 8a7.75 7.75 0 0115.5 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_62114_201"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    